import React, { Fragment, useContext, useState } from 'react'
import { AiOutlineQuestionCircle, AiFillFolder, AiFillFile, AiOutlineCloseCircle, AiOutlineSearch, AiOutlinePlusCircle } from 'react-icons/ai'

import { BiEdit } from 'react-icons/bi'
import Renderif from '../../components/renderif';
import SideMenu, { AdminSideMenu } from '../../components/sidemenu';
import DropDown, { DropDownOption } from '../../components/dropdown';
import { gray30, primary } from '../../utils/colors';
import { useNavigate } from 'react-router-dom';
import { Service } from '../../services/api';
import { AlertContext } from '../../context/alert_context';
import { GoStarFill } from "react-icons/go";
import { GoStar } from "react-icons/go";
import { AuthContext } from '../../context/auth_context';
import { AiFillCloseCircle } from 'react-icons/ai'
import Loader from '../../components/loader'
import { FiSettings } from 'react-icons/fi';





export default function TagsAdmin() {

    const { notify } = useContext(AlertContext)
    const navigate = useNavigate();
    const { user } = useContext(AuthContext)

    const [state, setState] = useState({
        tab: 0,
        show_add_tag: false,
        show_edit_tag: false,
        tag_editing: null,
        tags: [],
        loading: false,
    })





    const loadTags = async () => {
        let _tags = await Service('GET', 'Tag?pageNumber=1&pageSize=999');
        setState({ ...state, tags: _tags.data.data, show_add_tag: false, show_edit_tag: false })
    }

    useState(() => {
        const init = async () => {

            loadTags()


        };
        init();
        return () => { }
    }, [])


    const onNewTag = async () => {
        setState({ ...state, loading: true })
        let _tagName = document.getElementById('newTag').value;


        if (_tagName === '') {
            notify({ title: 'Error!', message: 'No se puede crear un tag sin nombre.', type: 'error' })
            setState({ ...state, loading: false })
        }
        else {
            let body = {
                "name": _tagName
            }

            const _newTag = await Service('POST', 'Tag', body);
            console.log(_newTag)

            if (_newTag?.status === 201) {
                notify({ title: 'Listo!', message: 'Se ha creado un nuevo tag.', type: 'success' })
                loadTags()

            } else {
                notify({ title: 'Error!', message: 'No se pudo crear el tag en este momento.', type: 'error' })
            }

            setState({ ...state, show_add_tag: false, loading: false })
        }


    }



    const onUpdateTag = async () => {
        // console.log(state.tag_editing);
        setState({ ...state, loading: true })

        if (state.tag_editing.name === '') {
            notify({ title: 'Error!', message: 'No se puede guardar un tag sin nombre.', type: 'error' })
            setState({ ...state, loading: false })
        }
        else {
            let body = {
                "name": state.tag_editing.name
            }

            const _newTag = await Service('PUT', `Tag/${state.tag_editing.id}`, body);
            console.log(_newTag)

            if (_newTag?.status === 200) {
                notify({ title: 'Listo!', message: 'Se ha actualizado el tag.', type: 'success' })
                loadTags()

            } else {
                notify({ title: 'Error!', message: 'No se pudo actualizar el tag en este momento.', type: 'error' })
            }

            setState({ ...state, show_edit_tag: false, loading: false })
        }
    }

    return (
        <>
            <Renderif isTrue={state.loading === true}>
                <Loader></Loader>
            </Renderif>
            <Renderif isTrue={state.show_add_tag}>
                <div className='overlay d-flex justify-content-center align-items-center'>
                    <div className='bv-modal shadow'>
                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                            <div className='f-16 text-gray'><strong>Nueva Etiqueta</strong></div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {

                                setState({ ...state, show_add_tag: false })

                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>
                        <div className='px-4 pb-5'>
                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Etiqueta</div>
                                <div className='input--light'>
                                    <input id='newTag' placeholder='Nueva Etiqueta'></input>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex b-top p-4'>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                setState({ ...state, show_add_tag: false })
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={async () => {
                                onNewTag()
                            }}>Continuar</div>
                        </div>
                    </div>
                </div>
            </Renderif>

            <Renderif isTrue={state.show_edit_tag}>
                <div className='overlay d-flex justify-content-center align-items-center'>
                    <div className='bv-modal shadow'>
                        <div className='px-4 pt-3 pb-4 d-flex align-items-center'>
                            <div className='f-16 text-gray'><strong>Nueva Etiqueta</strong></div>
                            <div className='col'></div>
                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {

                                setState({ ...state, show_edit_tag: false })

                            }}> <AiFillCloseCircle size={24} color="#30B7E7"></AiFillCloseCircle></div>
                        </div>
                        <div className='px-4 pb-5'>
                            <div className='mt-3'>
                                <div className='f-14 bold text-gray'>Etiqueta</div>
                                <div className='input--light'>
                                    <input value={state.tag_editing?.name} onChange={(evt) => {
                                        // state.specialist.firstName = evt.currentTarget.value
                                        console.log(evt.currentTarget.value)
                                        // if(evt.currentTarget.value !==''){
                                        //     console.log("correcto")
                                        // }
                                        // setState({ ...state })
                                        state.tag_editing.name = evt.currentTarget.value
                                        setState({ ...state })


                                    }}></input>
                                </div>
                            </div>
                        </div>
                        <div className='d-flex b-top p-4'>
                            <div className='col'></div>
                            <div className='bv-pill bv-pill--gray me-2 cursor-pointer' onClick={() => {
                                setState({ ...state, show_edit_tag: false })
                            }}>Cancelar</div>
                            <div className='bv-pill bv-pill--primary cursor-pointer' onClick={async () => {
                                onUpdateTag()
                            }}>Continuar</div>
                        </div>
                    </div>
                </div>
            </Renderif>

            <div className='container-fluid h-100 d-flex'>


                {/* <SideMenu></SideMenu> */}
                <AdminSideMenu></AdminSideMenu>

                <div className='col hide-scroll'>

                    <div className='container-fluid bg-light'>
                        <div className='container'>
                            <div className='d-flex align-items-center bg-light p-3'>


                                <div className='d-flex align-items-center '>
                                    <div className='avatar avatar--mid'></div>
                                    <div className='col ps-3'>
                                        <div className='f-18 bold '>¡Hola! {user.firstName} {user.lastName}.</div>
                                        <div className='text-gray f-14 line-0'>Medicina General</div>
                                    </div>
                                </div>
                                <div className='col'></div>
                                <div className='mx-3'>
                                        <div className='input--light'>
                                            <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                                            <input className='bg-transparent' placeholder='Buscar Tag' onChange={async (evt)  => {
                                                if (evt.currentTarget.value != '') {
                                                    console.log(evt.currentTarget.value)
                                                    let txt= evt.currentTarget.value.toUpperCase();
                                                    // loadUsers(evt.currentTarget.value);
                                                     
                                                    let _tags = await Service('GET', 'Tag?pageNumber=1&pageSize=999');
                                                    _tags=_tags.data.data.filter(item => item.name.toUpperCase().includes(txt))
                                                    setState({ ...state, tags: _tags, show_add_tag: false, show_edit_tag: false })
                                                    // setState()
                                                }
                                                else{
                                                    let _tags = await Service('GET', 'Tag?pageNumber=1&pageSize=999');
                                                    setState({ ...state, tags: _tags.data.data, show_add_tag: false, show_edit_tag: false })
                                                }

                                            }}></input>
                                        </div>
                                    </div>
                                <div className='pe-2'>
                                        <DropDown title={''} icon={<FiSettings size={24} color={gray30}></FiSettings>}>
                                            <DropDownOption disabled>
                                                <div className='d-flex align-items-center px-2'>

                                                    <div className='text-dark f-16 bold'>Etiquetas</div>

                                                    <div className='col mx-5'></div>

                                                    <div className='cursor-pointer text-decoration-underline text-primary bold f-14 prevent-select' onClick={() => {navigate('/administrador/tags')}}>Ver Etiquetas</div>

                                                </div>
                                            </DropDownOption>
                                        </DropDown>
                                    </div>
                                <div className='bv-cta bv-cta--primary' onClick={() => {
                                    // setState({...state, show_agendar_cita:true})
                                    navigate('/administrador/calendario')
                                }}>
                                    Ver Agenda

                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='container '>




                        <div className='row'>
                            <div className='col-12'>


                                <div className='d-flex align-items-center my-3'>
                                    <div className='bv-pill bv-pill--primary d-flex align-items-center ps-0 cursor-pointer me-1' onClick={() => {
                                        setState({ ...state, show_add_tag: true })
                                    }}>
                                        <div className='ps-0'> <AiOutlinePlusCircle size={22} /></div>
                                        <div className='px-1'>Agregar Tag</div>
                                    </div>
                                    <div className='col'></div>

                                </div>


                                <div className='bv-table d-none d-sm-block'>
                                    <table className='w-100'>
                                        <thead>
                                            <tr>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        {/* <div className='bv-icon'><BsCalendar size={12} color="#777777" /></div> */}
                                                        <div className='text-gray f-14 bold line-0'>Etiqueta</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        {/* <div className='bv-icon'><BsClock size={12} color="#777777" /></div> */}
                                                        <div className='text-gray f-14 bold line-0'>Tips</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                        <div className='text-gray f-14 bold line-0'>Documentos</div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        {/* <div className='bv-icon'><CgHashtag size={14} color="#777777" /></div> */}
                                                        <div className='text-gray f-14 bold line-0'>Acciones</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {state.tags.map((item, i) => {
                                                console.log(item)
                                                return (
                                                    <Fragment key={i}>
                                                        <tr className="">
                                                            <td>
                                                                <div>
                                                                    <div className='text-gray f-12'>{item.name}</div>

                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div>
                                                                    <div className='text-gray f-12'>0</div>

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div>
                                                                    <div className='text-gray f-12'>0</div>

                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='d-flex'>
                                                                    {/* <div className='pe-4'>
                                                                            <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                                                setState({ ...state, show_leave_especialist: true, especialistSelected: item })
                                                                            }}>
                                                                                <FiClock color={gray30} size={30}></FiClock>
                                                                            </div>
                                                                        </div> */}
                                                                    <div className='pe-4'>
                                                                        <div className='bv-icon bv-icon--mid cursor-pointer' onClick={() => {
                                                                            setState({ ...state, show_edit_tag: true, tag_editing: item })
                                                                        }}>
                                                                            <BiEdit color={primary} size={30}></BiEdit>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                        </tr>



                                                    </Fragment>
                                                )
                                            })}

                                        </tbody>

                                    </table>

                                    <div className='pt-5'></div>

                                    <div className='d-flex align-items-center p-2'>

                                        <div className='text-gray f-12 line-0'>Mostrar</div>


                                        <div className='mx-2'>
                                            <DropDown
                                                title=''
                                                open={false}
                                                defaultValue={5}
                                                _onChange={(evt) => {
                                                    console.log(evt)
                                                }}>
                                                <DropDownOption value={5} label="5">
                                                    <div className='f-14 text-gray'>5</div>
                                                </DropDownOption>
                                                <DropDownOption value={10} label="10">
                                                    <div className='f-14 text-gray'>10</div>
                                                </DropDownOption>



                                            </DropDown>
                                        </div>



                                        {/* <div className='d-flex bv-dropdown mx-2'>
                                        <div className='text-black bold f-12 ms-1'>5</div>
                                        <div className='line-0'><IoMdArrowDropdown size={18} color="#000000" /></div>
                                </div> */}


                                        <div className='text-gray f-12 line-0'>Por Página</div>
                                        <div className='col'></div>


                                    </div>
                                </div>

                            </div>

                        </div>




                    </div>

                    <div className='my-5'></div>
                </div>
            </div>
        </>
    )
}



export function Rating({ value = 5 }) {

    return (
        <div className='d-flex'>
            <div className='bv-icon '>

                <Renderif isTrue={value > 0}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 1}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>

            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 1}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 2}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 2}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 3}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 3}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 4}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>

            <div className='bv-icon'>
                <Renderif isTrue={value > 4}>
                    <GoStarFill color='#FFA800'></GoStarFill>
                </Renderif>
                <Renderif isTrue={value < 5}>
                    <GoStar color='#CCC'></GoStar>
                </Renderif>
            </div>
        </div>
    )
}


